import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { PRODUCT_PACKAGING_TYPE_TO_LABEL } from "@/constants/product"
import type { ProductPackagingType } from "@/graphql/codegen/graphql"

dayjs.extend(utc)

export const getProductPackagingTypeLabel = (packagingType: ProductPackagingType | null | undefined): string => {
  if (!packagingType) return ""

  return PRODUCT_PACKAGING_TYPE_TO_LABEL[packagingType] ?? packagingType
}

export function calculateRemainingShelfLife(
  manufacturingDate?: string | null,
  expirationDate?: string | null
): number | null {
  if (!manufacturingDate || !expirationDate) {
    return null
  }

  const mfgDate = dayjs.utc(manufacturingDate)
  const expDate = dayjs.utc(expirationDate)
  const currentDate = dayjs.utc()

  if (currentDate.isAfter(expDate)) {
    return 0
  }

  if (currentDate.isBefore(mfgDate)) {
    return 100
  }

  const totalShelfLife = expDate.diff(mfgDate, "day")

  if (totalShelfLife === 0) {
    return 0
  }

  const remainingDays = expDate.diff(currentDate, "day")
  const percentage = Math.round((remainingDays / totalShelfLife) * 100)

  return Math.max(0, Math.min(100, percentage))
}
